// Checks if pathname matches the pattern, where any parts in square brackets [*] are dynamic parts
// Eg pathname: /client/123/events/456/menu equals to pattern: /client/[hash]/events/[eventId]/menu
export const checkPathnamePattern = (
  pathname: string,
  pattern: string,
): boolean => {
  // Convert pattern to regular expression
  // Replace any parts in square brackets [*] with [^/]+ (any sequence of characters except /)
  const regexPattern = pattern
    .replace(/\[[^\]]+\]/g, "[^/]+") // Replace any [*] with [^/]+
    .replace(/\//g, "\\/"); // Escape slashes

  const regex = new RegExp(`^${regexPattern}$`);

  return regex.test(pathname);
};
